<template>
  <section>
    <Breadcrumb
      :sectionNames="breadcrumbs"
      :currentPageName="product.name"
    ></Breadcrumb>
    <div class="wrapper">
      <Spinner v-if="loading"></Spinner>

      <div v-else class="custom-container w-100 pt-3 pb-3">
        <div class="product-container">
          <div class="col-custom col-galery">
            <!-- gallery -->
            <div class="image-container d-flex" style="height:auto !important;">
              <zoom-on-hover
                class="main-img"
                :img-normal="mainImage && mainImage.length !== 0
                    ? mainImage
                    : '/template/images/no-image.png'"
              ></zoom-on-hover>
              <ul class="slides">
                <li
                  v-for="(image, index) in galleryList"
                  :key="'slide' + index"
                >
                  <img
                    :src="
                      image && image.length !== 0
                        ? image
                        : '/template/images/no-image.png'
                    "
                    alt="one"
                    @click="mainImage = image"
                    @error="image = '/template/images/no-image.png'"
                  />
                </li>
              </ul>
            </div>

            <!-- <div class="image-container d-flex">
              <ul class="slides">
                <li
                  v-for="(image, index) in product.images"
                  :key="'slide' + index"
                >
                  <img
                    v-lazy="
                      image && image.length !== 0
                        ? image
                        : '/template/images/no-image.png'
                    "
                    alt="one"
                    @click="mainImage = image"
                    @error="image = '/template/images/no-image.png'"
                  />
                </li>
              </ul>
              <img
                class="main-img"
                v-lazy="
                  mainImage && mainImage.length !== 0
                    ? mainImage
                    : '/template/images/no-image.png'
                "
                @error="mainImage = '/template/images/no-image.png'"
                alt=""
              />
            </div> -->
            <!-- gallery -->
          </div>

          <div class="col-custom col-intro" v-if="(product && product.body) || (parsedAudio && parsedAudio.length)">
            <div class="product-intro mt-2">
              <div v-if="product && product.body" class="intro-text" v-html="product.body"></div>
              <div v-if="parsedAudio && parsedAudio.length" class="intro-audio">
                <div v-for="(track, idx) in parsedAudio" :key="'right-audio-' + idx" class="audio-item">
                  <audio :src="track.url" controls preload="none" style="width: 100%"></audio>
                </div>
              </div>
            </div>
          </div>

          <div class="col-custom col-details">
            <!-- details -->
            <div class="details">
              <h5 style="max-width: 500px">{{ product.name }}</h5>
              <br />
              <label v-if="product.get_brand">
                ناشر:
                <router-link
                  :to="{
                    name: 'search',
                    query: {
                      brand: JSON.stringify([
                        {
                          id: product.get_brand.id,
                          name: product.get_brand.name
                        }
                      ])
                    }
                  }"
                >
                  {{ product.get_brand ? product.get_brand.name : "" }}
                </router-link>
              </label>
              <br />
              <label v-if="product.author">
                نویسنده:
                <router-link
                  :to="{
                    name: 'search',
                    query: {
                      author: JSON.stringify([
                        {
                          id: product.author_id,
                          name: product.author
                        }
                      ])
                    }
                  }"
                >
                  {{ product.author ? product.author : "" }}
                </router-link>
              </label>
              <br />
              <label v-if="product.translator">
                مترجم:
                <router-link
                  :to="{
                    name: 'search',
                    query: {
                      translator: JSON.stringify([
                        {
                          id: product.translator_id,
                          name: product.translator
                        }
                      ])
                    }
                  }"
                >
                  {{ product.translator ? product.translator : "" }}
                </router-link>
              </label>
              <br />
              <label
                v-if="
                  Number(publish.quantity) > 0 && Number(publish.quantity) < x
                "
              >
                وضعیت موجودی:
                <span style="color: darkred"
                  >تنها {{ publish.quantity }} عدد باقی مانده</span
                >
              </label>
              <label v-else-if="Number(publish.quantity) <= 0">
                وضعیت موجودی:
                <span style="color: red">ناموجود</span>
              </label>

              <!-- publish -->
              <div class="input-group">
                <label>نوبت چاپ</label>
                <select
                  class="form-control mr-2"
                  v-model="publish"
                  ref="publish"
                  @change="calculatePrice()"
                >
                  <option
                    v-for="(item, index) in product.dynamicAttributes"
                    :key="'publish' + index"
                    :value="item"
                  >
                    {{ item.publish }}
                  </option>
                </select>
              </div>
              <!-- publish -->

              <br />

              <!-- counter -->
              <div v-if="Number(publish.quantity) !== 0" class="input-group">
                <label>تعداد</label>
                <counter
                  ref="counter"
                  :min="product.min_limit ? product.min_limit : 1"
                  :max="
                    product.max_limit &&
                    Number(product.max_limit) < Number(publish.quantity)
                      ? product.max_limit
                      : publish.quantity
                  "
                  :value="product.min_limit ? product.min_limit : 1"
                  @input="count = $event"
                ></counter>
              </div>
              <!-- counter -->

              <br />

              <!-- favorite -->
              <FavoriteAction :productId="product.id"></FavoriteAction>
              <!-- favorite -->

              <br />

              <!-- special price -->
              <div v-if="publish.special_price && publish.special_price !== 0">
                <div class="d-flex">
                  <p class="old-price">
                    {{
                      new Intl.NumberFormat().format(publish.back_cover_price)
                    }}
                    ریال
                  </p>
                  <p class="discount-percent mr-2">
                    <!-- {{
                      publish.special_price > 100
                        ? new Intl.NumberFormat().format(publish.special_price)
                        : publish.special_price + "%"
                    }} -->
                    {{
                      new Intl.NumberFormat().format(
                        (
                          ((Number(publish.back_cover_price) -
                            Number(publish.special_price)) /
                            Number(publish.back_cover_price)) *
                          100
                        ).toFixed(0)
                      ) + "%"
                    }}
                  </p>
                </div>
                <p class="new-price">
                  <!-- {{
                    publish.special_price > 100
                      ? new Intl.NumberFormat().format(
                          Number(publish.back_cover_price) -
                            Number(publish.special_price)
                        )
                      : new Intl.NumberFormat().format(
                          (
                            Number(publish.back_cover_price) -
                            (Number(publish.back_cover_price) *
                              Number(publish.special_price)) /
                              100
                          ).toFixed(0)
                        )
                  }} -->
                  {{ new Intl.NumberFormat().format(publish.special_price) }}
                  ریال
                </p>
              </div>
              <!-- special price -->

              <!-- price -->
              <p v-else class="new-price">
                {{ new Intl.NumberFormat().format(publish.back_cover_price) }}
                ریال
              </p>
              <!-- price -->

              <input
                v-if="Number(publish.quantity) === 0"
                @click="registerOrder()"
                class="info-btn"
                type="button"
                value="سفارش کالا"
              />
              <input
                v-else
                @click="addToCard()"
                class="submit-btn"
                type="button"
                value="افزودن به سبد خرید"
              />
              
              <!-- Print Editions Box -->
              <div class="print-editions-box mt-4">
                <h6 class="editions-title">نوبت چاپ های موجود</h6>
                <div class="editions-grid">
                  <div 
                    v-for="(item, index) in product.dynamicAttributes" 
                    :key="'edition' + index"
                    class="edition-box"
                    :class="{ 'has-discount': item.special_price && item.special_price !== 0, 'active': publish.id === item.id }"
                    @click="selectPrintEdition(item)"
                    style="cursor: pointer;"
                  >
                    <div class="edition-number">چاپ {{ item.publish }}</div>
                    <div class="edition-price">
                      <template v-if="item.special_price && item.special_price !== 0">
                        <div class="original-price">
                          {{ new Intl.NumberFormat().format(item.back_cover_price) }} ریال
                        </div>
                        <div class="special-price">
                          {{ new Intl.NumberFormat().format(item.special_price) }} ریال
                        </div>
                      </template>
                      <template v-else>
                        {{ new Intl.NumberFormat().format(item.back_cover_price) }} ریال
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Print Editions Box -->
              
              <!-- details -->
            </div>
            <!-- details -->
          </div>
          
          <div class="col-custom col-video" v-if="videoUrl">
            <h6 class="video-title">ویدئوی معرفی</h6>
            <video :src="videoUrl" controls style="width: 100%; border-radius: 8px; background:#000"></video>
          </div>
        </div>
        <ProductContent
          :product="product"
          :publish="publish"
          :category="breadcrumbs[3] ? breadcrumbs[3] : ''"
        ></ProductContent>
        <br />
        <div v-if="showRelative">
          <RelativeProduct :productid="product.id"></RelativeProduct>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import ProductContent from "@/components/ProductContent.component";
import FavoriteAction from "@/components/FavoriteAction.component";
import Breadcrumb from "@/components/breadcrumb.component";
import counter from "@/components/counter.component";
import RelativeProduct from "@/components/slider/RelativeProduct.component";
import Spinner from "@/components/Spinner.component";

export default {
  name: "ProductPage",
  components: {
    Breadcrumb,
    ProductContent,
    FavoriteAction,
    counter,
    RelativeProduct,
    Spinner
  },
  data() {
    return {
      loading: true,
      breadcrumbs: [],
      productInfo: {},
      mainImage: "",
      selected: {},
      product: {},
      publish: {
        id: "",
        price: ""
      },
      count: 0,
      price: 0,
      x: "",
      showRelative: false
    };
  },
  watch: {
    count(newVal) {
      if (this.$refs.counter) {
        this.$refs.counter.count = newVal;
      }
    }
  },
  created() {
    //get product
    this.$store
      .dispatch("getProduct", { slug: this.$route.params.slug })
      .then(result => {
        this.product = result.items;
        this.mainImage = (this.product && Array.isArray(this.product.gallery) && this.product.gallery.length)
          ? this.product.gallery[0]
          : (this.product.intro_image || "");
        if (
          this.product.dynamicAttributes &&
          this.product.dynamicAttributes.length > 0
        ) {
          this.publish = this.product.dynamicAttributes[0];
          this.count = this.product.min_limit ? this.product.min_limit : 1;
        }
        this.x = result.show_qty;
        this.breadcrumbs = result.breadcrumb;
        this.showRelative = true;
        //this.product.qty = 0;//for test
        // this.calculatePrice();
        this.loading = false;
      });
  },
  computed: {
    galleryList() {
      try {
        const g = this.product && Array.isArray(this.product.gallery) ? this.product.gallery : [];
        if (g && g.length) return g.map(x => String(x).replace(/\\\//g, '/').replace(/\\/g, ''));
        const imgs = this.product && Array.isArray(this.product.images) ? this.product.images : [];
        if (imgs && imgs.length) return imgs;
        const intro = this.product && this.product.intro_image ? [this.product.intro_image] : [];
        return intro;
      } catch (e) {
        return [];
      }
    },
    parsedAudio() {
      try {
        if (!this.product || !this.product.audio) return [];
        const raw = this.product.audio;
        let arr;
        if (Array.isArray(raw)) {
          arr = raw;
        } else {
          try {
            arr = JSON.parse(raw);
          } catch (e) {
            // Fallback: extract download_link values via regex from raw string
            const matches = (String(raw).match(/"download_link"\s*:\s*"([^"]+\.mp3)"/g) || [])
              .map(m => m.replace(/.*:\s*"/, '').replace(/"$/, ''));
            const base = 'https://server.cheshmehdis.com/storage/';
            arr = matches.map(link => {
              const normalized = link.replace(/\\\//g, '/').replace(/\\/g, '');
              const path = normalized.replace(/^\/*/, '');
              const url = /^https?:\/\//i.test(normalized) ? normalized : (base + path);
              return { url };
            });
          }
        }
        if (!Array.isArray(arr)) return [];
        const explicitBase = 'https://server.cheshmehdis.com/storage/';
        return arr
          .filter(it => it && (it.download_link || it.url))
          .map(it => {
            const dl = it.download_link || it.url || '';
            const normalized = String(dl).replace(/\\\//g, '/').replace(/\\/g, '');
            const path = normalized.replace(/^\/*/, '');
            const url = /^https?:\/\//i.test(normalized) ? normalized : explicitBase + path;
            return { url };
          });
      } catch (e) {
        return [];
      }
    },
    videoUrl() {
      try {
        if (!this.product || !this.product.video) return "";
        const base = 'https://server.cheshmehdis.com/storage/';
        const raw = this.product.video;
        let candidate = null;
        if (Array.isArray(raw)) {
          // try first item with download_link or url
          const it = raw.find(x => x && (x.download_link || x.url)) || raw[0];
          if (!it) return "";
          candidate = it.download_link || it.url || '';
        } else if (typeof raw === 'string') {
          // attempt JSON parse first
          let parsed = null;
          try {
            parsed = JSON.parse(raw);
          } catch (e) {
            parsed = null;
          }
          if (parsed) {
            if (Array.isArray(parsed)) {
              if (!parsed.length) return ""; // empty array means no video
              const it = parsed.find(x => x && (x.download_link || x.url)) || parsed[0];
              if (it) candidate = it.download_link || it.url || '';
            } else if (parsed && (parsed.download_link || parsed.url)) {
              candidate = parsed.download_link || parsed.url || '';
            }
          }
          if (!candidate) {
            // fallback: consider the raw string only if it is a meaningful non-empty url-like string
            const trimmed = String(raw).trim();
            if (!trimmed || trimmed === '[]' || trimmed === '{}' || trimmed === 'null' || trimmed === '""') {
              return "";
            }
            candidate = trimmed;
          }
        } else if (typeof raw === 'object') {
          candidate = raw.download_link || raw.url || '';
        }
        if (!candidate) return "";
        const normalized = String(candidate).replace(/\\\//g, '/').replace(/\\/g, '');
        const hasProtocol = /^https?:\/\//i.test(normalized);
        const path = normalized.replace(/^\/*/, '');
        return hasProtocol ? normalized : base + path;
      } catch (e) {
        return "";
      }
    }
  },
  methods: {
    selectPrintEdition(edition) {
      this.publish = { ...edition };
      this.count = this.product.min_limit ? this.product.min_limit : 1;
      this.calculatePrice();
    },
    calculatePrice() {
      this.updateImages();
      this.count = this.product.min_limit ? this.product.min_limit : 1;
      //reset count
      return (
        Number(this.count) *
        Number(
          this.publish.special_price && this.publish.special_price !== 0
            ? this.publish.special_price
            : this.publish.back_cover_price
        )
      );
    },
    updateImages() {
      if (this.publish) {
        this.$store
          .dispatch("getProductImages", {
            main_code: this.publish.main_code
          })
          .then(res => {
            console.log(res);
            this.product.gallery = res;
            this.mainImage = (res && res.length ? res[0] : this.mainImage);
          });
      }
    },
    addToCard() {
      if (!this.publish || !this.publish.id || this.count <= 0) {
        this.$refs.publish.focus();
        return;
      }

      //save in localstorage and update basket
      let selected = {
        image: this.product.intro_image,
        productId: this.product.id,
        name: this.product.name,
        min_limit: this.product.min_limit,
        max_limit: this.product.max_limit,
        quantity: this.count,
        publish: this.publish, //pass all publish
        options: this.publish.id,
        // publish: this.publish,
        publish_quantity: this.publish.quantity,
        price: this.publish.back_cover_price,
        special_price: this.publish.special_price
      };

      this.$store.dispatch("addToBasket", {
        product: selected
      });
      // .then(product => {
      //if user is login save in db
      if (localStorage.getItem("token")) {
        //enable loader
        // this.basketLoading = true;

        this.$store
          .dispatch("addToBasketReq", { product: selected })
          .then(res => {
            if (!res) {
              this.$swal
                .fire({
                  position: "center",
                  icon: "warning",
                  title: "خطا در اضافه کردن محصول",
                  showConfirmButton: false,
                  timer: 1500
                })
                .then(() => {
                  //failed then remove from basket
                  this.$store.dispatch("removeFromBasket", {
                    product: selected
                  });
                });
            }
            //disable loader
            // this.basketLoading = false;
          });
      }
      // });
    },
    registerOrder() {
      let selected = {
        productId: this.product.id,
        attrId: this.publish.id,
        quantity: this.count
      };

      //enable loader
      this.loading = true;

      this.$store
        .dispatch("registerOrder", {
          options: selected
        })
        .then(result => {
          if (result === 401) {
            this.$swal
              .fire({
                position: "center",
                icon: "warning",
                title: "لطفا وارد حساب کاربری خود شوید !",
                showConfirmButton: false,
                timer: 1500
              })
              .then(() => {
                this.$router.push({ name: "auth" });
                return;
              });
          } else if (result === 200) {
            this.$swal.fire({
              position: "center",
              icon: "success",
              title: "سفارش شما با موفقیت ثبت شد",
              showConfirmButton: false,
              timer: 1500
            });
          } else {
            this.$swal.fire({
              position: "center",
              icon: "error",
              title: "ثبت درخواست با مشکل مواجه شد",
              showConfirmButton: false,
              timer: 1500
            });
          }

          //disable loader
          this.loading = false;
        });
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.loading = true;

    //get product
    this.$store
      .dispatch("getProduct", { slug: to.params.slug })
      .then(result => {
        this.product = result.items;
        this.mainImage = this.product.intro_image;
        if (
          this.product.dynamicAttributes &&
          this.product.dynamicAttributes.length > 0
        ) {
          this.publish = this.product.dynamicAttributes[0];
          this.count = this.product.min_limit ? this.product.min_limit : 1;
        }
        this.x = result.show_qty;
        this.breadcrumbs = result.breadcrumb;
        this.showRelative = true;
        //this.product.qty = 0;//for test
        // this.calculatePrice();
        this.loading = false;
      });
    next();
  }
};
</script>
<style scoped>
.product-container{
  background: #e7e7e7 !important;
  padding: 12px;
  border-radius: 20px;
  display: grid;
  grid-template-columns: 380px 1fr 1.1fr 420px; /* from right: gallery, intro, info, video */
  grid-auto-flow: dense;
  gap: 16px;
  direction: rtl; /* ensure visual order from right */
}
/* Columns sizing */
.product-container .col-galery { max-width: 380px; }
.product-container .col-details { min-width: 360px; }
.product-container .col-intro { min-width: 300px; }
.product-container .col-video { min-width: 320px; }
/* Top intro styles */
.product-intro {
  background: #ffffff;
  border: 1px solid #e7e7e7;
  border-radius: 8px;
  padding: 10px 12px;
  margin: 6px 0 10px;
}
.book-title { font-weight: 700; font-size: 1.05rem; margin: 0 0 6px; }
.video-title { font-weight: 600; margin-bottom: 8px; text-align: right;}
.product-intro .intro-text {
  line-height: 2;
  direction: rtl;
  text-align: right;
  white-space: pre-line; /* preserve \n as line breaks */
}
.product-intro .audio-item {
  margin-top: 10px;
}
/* Print Editions Box Styles */
.print-editions-box {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  margin-top: 20px;
}

.editions-title {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
  text-align: center;
}

.editions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
  justify-content: space-between;
}

.edition-box {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 12px 8px;
  text-align: center;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
}

.edition-box:hover {
  border-color: #007bff;
  box-shadow: 0 0 0 1px rgba(0, 123, 255, 0.25);
}

.edition-box.active {
  background-color: #e6f2ff;
  border-color: #4d94ff;
  box-shadow: 0 0 0 2px rgba(77, 148, 255, 0.3);
  transform: translateY(-2px);
}

.edition-box.active .edition-number {
  color: #0056b3;
  font-weight: 600;
}

.edition-box.active.has-discount::before {
  background-color: #c82333;
  font-weight: bold;
}

.edition-box.has-discount::before {
  content: 'تخفیف';
  position: absolute;
  top: 5px;
  left: 5px;
  background-color: #dc3545;
  color: white;
  font-size: 0.7rem;
  padding: 1px 8px;
  border-radius: 10px;
  transform: rotate(-15deg);
}

.edition-number {
  font-size: 0.9rem;
  font-weight: 500;
  color: #333;
  margin-bottom: 5px;
}

.edition-price {
  font-size: 0.9rem;
  font-weight: 500;
  direction: rtl;
}

.edition-price .original-price {
  text-decoration: line-through;
  color: #999;
  font-size: 0.8rem;
  margin-bottom: 2px;
}

.edition-price .special-price {
  color: #28a745;
  font-weight: 600;
  display: block;
  margin-top: 2px;
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .editions-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.main-img .normal {
  height: 500px !important;
}
.details {
  margin-top: 0.5rem;
  display: flex;
  flex-flow: column;
  text-align: right;
  line-height: 1;
  height: 100%;
  min-width: 400px;
  justify-content: space-between;
}

.image-container {
  width: 360px;
  margin-left: 20px;
  flex-flow: column;
}

.image-container ul {
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  margin: 10px 0 0 0 !important;
  padding: 6px 0;
}

.image-container ul li {
  padding: 0;
}

.image-container ul::-webkit-scrollbar {
  height: 6px;
  border-radius: 5px;
}

.image-container ul::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
}

.image-container ul::-webkit-scrollbar-thumb {
  background-color: darkgrey;
}

.image-container .main-img {
  max-width: 360px;
  margin: 0 auto;
}

.image-container ul li img {
  width: 64px;
  height: 86px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  cursor: pointer;
}

/* price css */
.old-price {
  font-size: 24px !important;
}

.new-price {
  font-size: 24px !important;
}
  .product-container{
    background: #e7e7e7 !important;
    padding: 12px;
    border-radius: 20px;
  }
/* price css */

/* Responsive grid */
@media screen and (max-width: 1200px) {
  .product-container {
    grid-template-columns: 360px 1fr 1fr; /* hide 4th implicitly when not present */
  }
}
@media screen and (max-width: 992px) {
  .product-container {
    grid-template-columns: 1fr 1fr; /* two columns */
  }
}
@media screen and (max-width: 550px) {
  .product-container { grid-template-columns: 1fr; }
  .image-container-div {
    width: 100%;
  }

  .image-container {
    flex-flow: column;
    max-height: 100%;
    width: 100%;
  }

  .image-container .slides {
    display: flex;
    margin-top: 1rem;
    overflow-x: auto;
    overflow-y: hidden;
    justify-content: center;
  }

  .image-container ul li {
    display: flex;
  }

  .col-custom {
    width: 100%;
  }

  .details {
    min-width: 100%;
  }

  .image-container .main-img {
    /* width: 90% !important; */
    margin: 0 auto;
  }

}
</style>
